import { render, staticRenderFns } from "./PrimerOET.vue?vue&type=template&id=6ea1fb63&scoped=true&"
import script from "./PrimerOET.vue?vue&type=script&lang=js&"
export * from "./PrimerOET.vue?vue&type=script&lang=js&"
import style0 from "./PrimerOET.vue?vue&type=style&index=0&id=6ea1fb63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea1fb63",
  null
  
)

export default component.exports